// extracted by mini-css-extract-plugin
export default {"shorterPostContent":"component-styles_shorterPostContent__DQzcI"};